(function () {
  function initCollectionSeo(section) {
    if (!section || section.dataset.collectionSeoInitialized === "true") {
      return;
    }

    var content = section.querySelector("[data-collection-seo-content]");
    var toggle = section.querySelector("[data-collection-seo-toggle]");
    var label = section.querySelector("[data-collection-seo-label]");
    var icon = section.querySelector(".wc-collection-seo__toggle-icon");

    if (!content || !toggle || !label || !icon) {
      return;
    }

    var labelOpen = toggle.dataset.labelOpen || "Lire la suite";
    var labelClose = toggle.dataset.labelClose || "Réduire";
    var resizeTimer;

    function getCollapsedHeight() {
      var styles = window.getComputedStyle(section);

      var variableName =
        window.innerWidth <= 749
          ? "--wc-seo-collapsed-height-mobile"
          : "--wc-seo-collapsed-height";

      return parseFloat(styles.getPropertyValue(variableName)) || 0;
    }

    function setClosedState() {
      content.classList.remove("is-open");
      content.style.maxHeight = "";

      toggle.setAttribute("aria-expanded", "false");
      label.textContent = labelOpen;
      icon.textContent = "+";
    }

    function setOpenState() {
      content.classList.add("is-open");
      content.style.maxHeight = content.scrollHeight + "px";

      toggle.setAttribute("aria-expanded", "true");
      label.textContent = labelClose;
      icon.textContent = "−";
    }

    function updateState() {
      var wasOpen = content.classList.contains("is-open");

      content.style.maxHeight = "";
      content.classList.remove("is-collapsible");

      var collapsedHeight = getCollapsedHeight();
      var shouldCollapse = content.scrollHeight > collapsedHeight + 10;

      if (!shouldCollapse) {
        toggle.hidden = true;
        setClosedState();
        return;
      }

      toggle.hidden = false;
      content.classList.add("is-collapsible");

      if (wasOpen) {
        setOpenState();
      } else {
        setClosedState();
      }
    }

    toggle.addEventListener("click", function () {
      if (content.classList.contains("is-open")) {
        setClosedState();
      } else {
        setOpenState();
      }
    });

    window.addEventListener("resize", function () {
      clearTimeout(resizeTimer);

      resizeTimer = setTimeout(function () {
        updateState();
      }, 150);
    });

    section.dataset.collectionSeoInitialized = "true";

    requestAnimationFrame(function () {
      updateState();
    });
  }

  function initAllCollectionSeo(root) {
    (root || document)
      .querySelectorAll("[data-collection-seo]")
      .forEach(initCollectionSeo);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () {
      initAllCollectionSeo(document);
    });
  } else {
    initAllCollectionSeo(document);
  }

  document.addEventListener("shopify:section:load", function (event) {
    initAllCollectionSeo(event.target);
  });
})();